// 统一提交函数：send_beacon + fetch 双重保障
function submitStatic(eventType, value) {
    const pageUrl = window.location.href;
    const referrer = document.referrer;
    const data = {
        token: 'c046e9b0778f1cb765942d6523dbb816',
        pageUrl: pageUrl,
        referrer: referrer,
        eventType: eventType,
        value: value,
        shop_id: 2
    };
    const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });

    if (navigator.sendBeacon) {
        const sent = navigator.sendBeacon('https://tj.coopez.cn', blob);
        if (!sent) {
            fallbackFetch(data);
        }
    } else {
        fallbackFetch(data);
    }
}

function fallbackFetch(data) {
    fetch('https://tj.coopez.cn', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        keepalive: true
    }).catch(error => console.error('提交访问记录失败:', error));
}

// 页面加载完成后发送 page_view 事件
// if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', () => submitStatic('page-view', window.location.href));
// } else {
//     submitStatic('page-view', window.location.href);
// }



let startTime = new Date();

/**
 * 保存停留时间
 */
function saveStayTime() {
    const endTime = new Date();
    const stayTime = Math.floor((endTime - startTime) / 1000); // 秒

    const hours = Math.floor(stayTime / 3600);
    const minutes = Math.floor((stayTime % 3600) / 60);
    const seconds = stayTime % 60;

    let timeText = "";
    if (hours > 0) timeText += hours + "小时";
    if (minutes > 0) timeText += minutes + "分";
    timeText += seconds + "秒";

    submitStatic('stayTime', timeText);
}

// 页面可见性变化（切换标签/最小化）
document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
        saveStayTime();
    } else if (document.visibilityState === "visible") {
        startTime = new Date();
    }
});

// 页面关闭/刷新/前进后退
// window.addEventListener("pagehide", function () {
//     saveStayTime();
// });



